import React from "react";
import Top from "../Top";
import Left from "../Left";
import { useNavigate } from "react-router-dom";
import { Button, Grid } from "@mui/material";
import Switch from "@mui/material/Switch";

// For Modal
import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";

import swal from "sweetalert";

import { makeGetRequest, makePostRequest } from "../../utils/utils.js";
// End

function AssignRights() {
  const navigate = useNavigate();

  // const addCommitee = () => {
  //   var element = document.getElementById("successfullAdd");
  //   element.classList.toggle("hideModal");
  // };

  // For Modal
  const [open, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState("paper");

  const handleClickOpen = (scrollType) => () => {
    setOpen(true);
    setScroll(scrollType);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const descriptionElementRef = React.useRef(null);

  const [modulesList, setModulesList] = React.useState([]);
  const [societiesList, setSocietiesList] = React.useState([]);
  const [societyCode, setSocietyCode] = React.useState();
  const [assignRightsId] = React.useState();
  const [isActive] = React.useState();
  const [moduleJsonList, setModuleJsonList] = React.useState([]);

  async function GetAllSocieties() {
    await makeGetRequest("society/getall")
      .then((response) => {
        console.log(response);
        if (response.status == "201") {
          console.log(response.data.data);
          const data = response.data.data.rows;
          console.log(data);
          setSocietiesList(data);
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }
  async function addModule() {
    let moduleName = document.getElementById("moduleNameId").value;
    let isGetByName = "";
    if (moduleName) {
      await makeGetRequest("societymodule/getbymodulename/" + moduleName).then(
        (response) => {
          console.log(response);

          if (response.data.data) {
            isGetByName = true;
          } else isGetByName = false;
        }
      );

      if (isGetByName) {
        swal(
          "Unable To Add Module ",
          "Module With The Same Name Already Exist",
          "warning"
        );
      } else {
        let inputdata = {
          module_name: moduleName,
        };

        await makePostRequest("societymodule/insert", inputdata)
          .then((response) => {
            console.log(response);
            if (response.data.data !== undefined) {
              swal("Success", "Module added successfully", "success", {
                timer: 1000,
                buttons: false,
              });
              document.getElementById("moduleNameId").value = "";
              GetAllModules();
            }
          })
          .catch((err) => {
            swal(" " + err.message, "Please use other details", "warning");
          });
      }
    } else {
      swal("Please add module Name First.. ", "warning");
    }
  }

  async function GetAllModules() {
    await makeGetRequest("societymodule/getall")
      .then((response) => {
        // console.log(response);
        if (response.status == "201") {
          console.log(response.data.data);
          const data = response.data.data;
          console.log(data);
          setModulesList(data);
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  async function assignRights() {
    let inputdata = "";

    if (isRightsAssigned) {
      inputdata = {
        asignrights_id: assignRightsId,
        society_code: societyCode,
        lst_modules: moduleJsonList,
      };

      await makePostRequest("asignrights/update", inputdata)
        .then((response) => {
          console.log(response);
          if (response.data.data !== undefined) {
            swal("Success", "ReAssigned Rights Successfully", "success", {
              timer: 1000,
              buttons: false,
            });
            // document.getElementById('moduleNameId').value="";
            navigate("/SocietyAdmin");
          }
        })
        .catch((err) => {
          swal(" " + err.message, "Please use other details", "warning");
        });
    } else {
      inputdata = {
        society_code: societyCode,
        lst_modules: moduleJsonList,
      };

      if (moduleJsonList.length > 0) {
        await makePostRequest("asignrights/insert", inputdata)
          .then((response) => {
            console.log(response);
            if (response.data.data !== undefined) {
              swal(
                "Rights Assigned successfully",
                "Please Add Society Admin",
                "success",
                {
                  timer: 1000,
                  buttons: false,
                }
              );
              // document.getElementById('moduleNameId').value="";
              navigate("/SocietyAdmin");
            }
          })
          .catch((err) => {
            swal(" " + err.message, "Please use other details", "warning");
          });
      }
      //  else {
      //   swal("Unable To Assign Rights ", "No Module Selected", "warning");
      // }
    }
  }

  const [isRightsAssigned, setIsRightsAssigned] = React.useState(false);

  async function handleChangeSociety(e) {
    // alert(e.target.value)
    setSocietyCode(e.target.value);

    await makeGetRequest("asignrights/getbysocietycode/" + e.target.value)
      .then((response) => {
        console.log(response);
        if (response.data.data) {
          setModulesList([]);
          swal(
            "Rights Already Assigned to This Society!",
            "You Can Change The Rights If Needed.",
            "warning"
          );
          setIsRightsAssigned(true);
          GetAllModules();
        } else {
          GetAllModules();
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  let moduleJson = { module_name: "", isAccess: "" };

  async function handleChangeModuleStatus(e, moduleName) {
    console.log(e);
    // alert(e.target.checked)
    console.log("Before Push ", moduleJsonList.length);

    //   if(moduleJsonList.size>0)
    //   {
    //     console.log('Obj ',obj)
    //     const obj = moduleJsonList.find((item) => item.hasOwnProperty(moduleName));
    //     console.log(obj)
    // }
    moduleJson = {};
    moduleJson.module_name = moduleName;
    moduleJson.isAccess = e.target.checked;
    moduleJsonList.push(moduleJson);
    setModuleJsonList(moduleJsonList);
  }

  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
    GetAllSocieties();
  }, [open]);
  // End

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">Assign Rights</h1>
            <Button className="primaryBtn" onClick={handleClickOpen("body")}>
              Add New Module
            </Button>
          </Grid>
          <Grid item xs={12} md={12}>
            <div className="residentManagementTable">
              <div className="visitorListNewOut">
                <div className="visitorHead">Assign Rights</div>
                <div className="visitorListNewInner">
                  <div className="assignRightMain">
                    <div className="assignRightInner">
                      <div className="assignRightDivSelect">
                        <label className="forSelectSocietyLabel">
                          Select Society
                        </label>
                        <select
                          className="inputSt"
                          value={societyCode}
                          onChange={handleChangeSociety}
                        >
                          <option></option>
                          {societiesList.map((key) => (
                            <option
                              key={key.society_code}
                              value={key.society_code}
                              data-isd={key.society_name}
                            >
                              {key.society_name}
                            </option>
                          ))}
                        </select>
                      </div>
                      {modulesList.map((option) => (
                        <div className="assignRightDiv">
                          <h2>{option.module_name}</h2>
                          <Switch
                            checked={isActive}
                            size="small"
                            onChange={(e) =>
                              handleChangeModuleStatus(e, option.module_name)
                            }
                          />
                        </div>
                      ))}
                      &nbsp;
                      <div className="assignBtOuter">
                        {isRightsAssigned ? (
                          <Button
                            className="addBt PreviewBtn"
                            onClick={() => assignRights()}
                          >
                            ReAssign Rights
                          </Button>
                        ) : (
                          <Button
                            className="addBt PreviewBtn"
                            onClick={() => assignRights()}
                          >
                            Assign Rights
                          </Button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>

      <div className="modalMain">
        <Dialog
          open={open}
          // onClose={handleClose}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Add New Module</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <div id="successfullAdd">
                <Grid container spacing={3} className="addCommitee1">
                  <Grid item xs={12} md={12}>
                    <input
                      className="modalInputStSelect"
                      placeholder="Enter Module Name"
                      id="moduleNameId"
                    />
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <div className="modalMainBtMain">
                      <Button
                        className="modalMainBt"
                        onClick={() => addModule()}
                      >
                        Add Module
                      </Button>
                    </div>
                  </Grid>
                </Grid>

                <Grid container spacing={3} className="addCommitee2">
                  <Grid item xs={12} md={12}>
                    <div className="succesMain">
                      <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfz3upZJUzgki4bn27faJf6gPIIo7Yo5HxZg&usqp=CAU" />
                      <h4>Success !</h4>
                      <p>
                        Module added <br />
                        successfully in database
                      </p>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
}

export default AssignRights;
